<template>
  <div class="card-body mt-3 pt-0" style="padding:20px 20px 15px 20px">    
    <div v-if="mensagem">{{ mensagem }}</div>
    <div v-else>
      <div v-for="(item, index) in alteracoesNCM" :key="index">
        <card-ncm :alteracao="item" />
      </div>
    </div>
  </div>
</template>

<script>
import cardncm from "../../shared/cardNCM";
export default {
  props: {
    alteracoesNCM: {},
    mensagem: ""
  },
  components: {
    "card-ncm": cardncm
  },
  created() {}
};
</script>

<style scoped>
</style>